import { useState } from 'react';
import { toaster } from 'evergreen-ui';
import { requestFerie, fetchFerieRequests, updateFerieRequestStatus } from '../../services/turniService';
import { useRole } from '../../contexts/RoleContext';
import { useAuth } from '../../services/authContext';

const useFerie = ({ userName, onFerieApproved }) => {
  const { effectiveIsDirector: isDirector } = useRole();
  const { user } = useAuth();
  const [managerFerieList, setManagerFerieList] = useState([]);
  const [ferieInputs, setFerieInputs] = useState({
    start_date: '',
    end_date: '',
    start_time: '',
    end_time: '',
    motivazione: '',
    operator_name: userName,
    type: 'Ferie',
    file: null,
  });

  const handleRequestFerie = async () => {
    try {
      const payload = { ...ferieInputs };
      await requestFerie(payload);
      toaster.success(isDirector ? 'Richiesta assenza approvata inserita' : 'Richiesta inviata con successo');
      setFerieInputs({ start_date: '', end_date: '', start_time: '', end_time: '', motivazione: '', operator_name: userName, type: 'Ferie', file: null });
      if (onFerieApproved) onFerieApproved();
      return true;
    } catch (e) {
      toaster.danger('Errore: ' + e.message);
      return false;
    }
  };

  const loadAllFerie = async () => {
    try {
      const reqs = await fetchFerieRequests();
      return reqs || [];
    } catch (e) {
      toaster.danger('Errore recupero richieste ferie: ' + e.message);
      return [];
    }
  };

  const handleOpenManagerFerie = async () => {
    const reqs = await loadAllFerie();
    setManagerFerieList(reqs);
    return reqs;
  };

  const handleOpenMyFerie = async () => {
    const reqs = await loadAllFerie();
    const myReqs = reqs.filter(req =>
      user?.id ? String(req.user_id) === String(user.id) : req.operator_name === userName
    );
    setManagerFerieList(myReqs);
    return myReqs;
  };

  const handleUpdateFerieStatus = async (id, newStatus) => {
    try {
      await updateFerieRequestStatus(id, newStatus);
      toaster.success(`Ferie o permesso ${newStatus}!`);
      const reqs = await fetchFerieRequests();
      setManagerFerieList(reqs || []);
      if (newStatus === 'approvata' && onFerieApproved) onFerieApproved();
    } catch (e) {
      toaster.danger('Errore durante aggiornamento ferie: ' + e.message);
    }
  };

  return {
    managerFerieList,
    setManagerFerieList,
    ferieInputs,
    setFerieInputs,
    handleRequestFerie,
    handleOpenManagerFerie,
    handleOpenMyFerie,
    handleUpdateFerieStatus,
  };
};

export default useFerie;
